export enum GenderUiPbEnum {
  Male = "MALE",
  Female = "FEMALE",
  Transgender = "TRANSGENDER",
}
